import type { VcsStatusResult, VmExecutionMode } from "@t3tools/contracts";

export type VmComposerExecutionMode = VmExecutionMode | "build" | "setup";

export interface VmSetupWorkspaceSource {
  readonly branch: string;
  readonly startFromOrigin: boolean;
}

export function resolveVmSetupWorkspaceSource(
  status:
    | Pick<VcsStatusResult, "isRepo" | "refName" | "hasPrimaryRemote" | "hasUpstream">
    | null
    | undefined,
): VmSetupWorkspaceSource | null {
  const branch = status?.refName?.trim();
  if (status?.isRepo !== true || !branch) return null;

  return {
    branch,
    startFromOrigin: status.hasPrimaryRemote && status.hasUpstream,
  };
}

export function formatVmSetupWorkspaceSource(
  source: VmSetupWorkspaceSource | null | undefined,
): string {
  if (!source) return "Setup workspace";
  const branch = source.branch.replace(/^origin\//, "");
  return source.startFromOrigin
    ? `Setup workspace · origin/${branch}`
    : `Setup workspace · ${branch}`;
}
